import styled from "styled-components";

import { EllipsisDropdownItem } from "@similarweb/ui-components";

export const EllipsisDropdownItemWrapper = styled(EllipsisDropdownItem)`
    div:nth-child(2) {
        flex-wrap: wrap;
        display: contents;
    }
`;

export const TextWrapper = styled.span`
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
`;
